import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetSection1Data, setGetSection2ListingData, setGetSection3ListingData, setGetSection3Single, setGetSection4ListingData, setGetSection4Single, setGetSection5ListingData, setGetSection5Single, setGetSection6ListingData, setGetSection6Single, setdatawhychoose, setgetfaqlisting, setgetsinglefaq, setgetsinglewhychoose } from "../reusable/reusableSlice";



export const addSection2Data = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("cms/add", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
       dispatch(section2ListingData({ section: 2,}));
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  export const addSection3Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/add", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/section3")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  
  export const addSection3WhychooseData = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/add", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/sectionwhychooose")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const addSection4Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/add", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/section4")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const addSection5Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/add", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/section5")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const addSectionfaqData = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/add", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/sectionfaq")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const addSection6Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/add", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/section6")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  export const getSection1DataSingleId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`cms/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setGetSection1Data(response?.data?.response))
      } else {
        dispatch(setGetSection1Data([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection1Data([]))
    }
  };

  export const updateSection1Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // window.location.reload()
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const section3ListingData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`cms/cms_list`,data);
      if (response?.data) {
        dispatch(setGetSection3ListingData(response?.data?.response))
      } else {
        dispatch(setGetSection3ListingData([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection3ListingData([]))
    }
  };

  export const sectionwhychooseListingData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`cms/cms_list`,data);
      if (response?.data) {
        dispatch(setdatawhychoose(response?.data?.response))
      } else {
        dispatch(setdatawhychoose([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setdatawhychoose([]))
    }
  };

  export const section2ListingData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`cms/cms_list`,data);
      if (response?.data) {
        dispatch(setGetSection2ListingData(response?.data?.response))
      } else {
        dispatch(setGetSection2ListingData([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection2ListingData([]))
    }
  };

  export const section4ListingData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`cms/cms_list`,data);
      if (response?.data) {
        dispatch(setGetSection4ListingData(response?.data?.response))
      } else {
        dispatch(setGetSection4ListingData([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection4ListingData([]))
    }
  };

  export const section5ListingData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`cms/cms_list`,data);
      if (response?.data) {
        dispatch(setGetSection5ListingData(response?.data?.response))
      } else {
        dispatch(setGetSection5ListingData([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection5ListingData([]))
    }
  };

  export const sectionfaqListingData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`cms/cms_list`,data);
      if (response?.data) {
        dispatch(setgetfaqlisting(response?.data?.response))
      } else {
        dispatch(setgetfaqlisting([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setgetfaqlisting([]))
    }
  };

  export const section6ListingData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`cms/cms_list`,data);
      if (response?.data) {
        dispatch(setGetSection6ListingData(response?.data?.response))
      } else {
        dispatch(setGetSection6ListingData([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection6ListingData([]))
    }
  };

  export const getSection3DataSingleId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`cms/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setGetSection3Single(response?.data?.response))
      } else {
        dispatch(setGetSection3Single([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection3Single([]))
    }
  };

  export const getSectionwhychooseDataSingleId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`cms/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setgetsinglewhychoose(response?.data?.response))
      } else {
        dispatch(setgetsinglewhychoose([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setgetsinglewhychoose([]))
    }
  };

  export const getSection4DataSingleId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`cms/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setGetSection4Single(response?.data?.response))
      } else {
        dispatch(setGetSection4Single([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection4Single([]))
    }
  };

  export const getSection5DataSingleId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`cms/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setGetSection5Single(response?.data?.response))
      } else {
        dispatch(setGetSection5Single([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection5Single([]))
    }
  };

  export const getSectionfaqDataSingleId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`cms/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setgetsinglefaq(response?.data?.response))
      } else {
        dispatch(setgetsinglefaq([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setgetsinglefaq([]))
    }
  };

  export const getSection6DataSingleId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`cms/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setGetSection6Single(response?.data?.response))
      } else {
        dispatch(setGetSection6Single([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSection6Single([]))
    }
  };

  export const updateSection3Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // window.location.reload()
        navigate("/section3")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const updateSectionwhychooseData = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // window.location.reload()
        navigate("/sectionwhychooose")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  export const updateSection4Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // window.location.reload()
        navigate("/section4")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const updateSection5Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // window.location.reload()
        navigate("/section5")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const updateSectionfaqData = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // window.location.reload()
        navigate("/sectionfaq")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const updateSection6Data = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("cms/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // window.location.reload()
        navigate("/section6")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const deleteSection = (id) => async (dispatch) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.delete(`cms/delete/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        dispatch(section2ListingData({ section: 2,}));
        dispatch(sectionfaqListingData({   section: 7,page: 1,}));
        // window.location.reload()
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      // setLoading(false);
    }
  };